var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "v-search" }, [
    _c("div", {
      staticClass: "v-search--icon i-search v-test",
      on: {
        click: function($event) {
          return _vm.toggleSearch()
        }
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "v-search__results",
        class: { "v-search--slide": _vm.slideResults }
      },
      [
        _c("div", { staticClass: "v-search__input-container" }, [
          _c("i", { staticClass: "v-search--icon i-search" }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchText,
                expression: "searchText"
              }
            ],
            attrs: {
              type: "text",
              name: "search-text",
              id: "search-text",
              placeholder: "search for products"
            },
            domProps: { value: _vm.searchText },
            on: {
              keyup: [
                function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  _vm.searchText = ""
                  _vm.toggleSearch()
                },
                function($event) {
                  return _vm.searchProducts()
                }
              ],
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.searchText = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("i", {
            staticClass: "v-search--icon v-search__close i-close",
            on: {
              click: function($event) {
                return _vm.toggleSearch()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "v-top-searched" },
          _vm._l(_vm.topSearched, function(product, index) {
            return _c("ProductItem", {
              key: index,
              attrs: {
                mainImage: product.image ? product.image : "",
                hoverImage: product.image_hover ? product.image_hover : "",
                title: product.title ? product.title : "",
                price: product.price ? product.price : 0,
                priceCompare: product.priceCompare ? product.priceCompare : "",
                handle: product.handle ? product.handle : ""
              }
            })
          }),
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }